import { useQuery } from '@tanstack/react-query';
import { getTemplates } from 'services/fileManager/fileManagerServices';
import { queryKeys } from 'hooks/config/queryClient';

export function useTemplatesQuery(params = '', enabled = true) {
  return useQuery({
    queryKey: queryKeys.fileManager.templates(params || ''),
    queryFn: async () => {
      const response = await getTemplates(params);
      return response?.data?.data || [];
    },
    enabled: enabled && !!params,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
